import React, { Component } from 'react';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import Layout from './components/scenes/Layout';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import routes from 'helpers/routes';
import './App.scss'

const queryClient = new QueryClient();

function App() {
    const location = useLocation();

    const routesConfig = (
        <Routes>
            {Object.keys(routes).map((page, index) =>
                <Route path={routes[page].path} element={routes[page].element} key={index} />
            )}
            <Route path="*" element={<RedirectToFirstChild />} />
        </Routes>
    );

    return (
        <div className="App">
            <QueryClientProvider client={queryClient}>
                {location.pathname === '/notes' ? (
                    routesConfig
                ) : (
                    <Layout>{routesConfig}</Layout>
                )}

                <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
        </div>
    );
}

// Redirect component for parent paths to first child
const RedirectToFirstChild: React.FC = () => {
    const location = useLocation();
    const pathname = location.pathname;
    const segments = pathname.split('/').filter(Boolean);

    if (segments.length === 1) {
        const parentPath = segments[0];
        const pageExists = Object.values(routes).some(route => route.path === '/' + parentPath);
        if (!pageExists) {
            const firstSubNav = Object.values(routes).find(route => route.path.startsWith('/' + parentPath + '/'));
            if (firstSubNav) {
                return <Navigate to={firstSubNav.path} replace />;
            }
        }
    }

    return <Navigate to="/" replace />;
};

export default App;